<template>
  <div>
    <div
      v-if="numRoom > 0"
      :class="{'mt-6' : numRoom > 0 && isRakutenPLan}"
      class="room-number">
      {{ numRoom + 1 }}部屋目
    </div>
      <div class="people-room mt-2 mb-3">
        <div class="room-row">
          <!-- PC -->
          <div class="row-content bgGray sm:hidden">
            <div class="content__item elem head age-group">
              年齢区分
              <span class="ml-4">必須</span>
            </div>
            <div class="content__item elem head member-type">
              会員・ビジター
              <span class="ml-4">必須</span>
            </div>
            <div class="content__item elem head sex-type">
              性別
              <span class="ml-4">必須</span>
            </div>
            <div class="content__item elem head main-accommodation">
              宿泊代表者
              <span class="ml-4">必須</span>
            </div>
            <div class="content__item elem head delete-lodger"></div>
          </div>
          <!-- SP -->
          <div class="row-content hidden bgGray sm:grid">
            <div class="content__item elem center head age-group">
              年齢区分
              <span>必須</span>
            </div>
            <div class="content__item elem center head member-type">
              会員・<br/>ビジター
              <span>必須</span>
            </div>
            <div class="content__item elem center head sex-type">
              性別
              <span>必須</span>
            </div>
            <div class="content__item elem center head main-accommodation">
              宿泊代表者
              <span>必須</span>
            </div>
            <div class="elem center head delete-lodger bgGray"></div>
          </div>
        </div>
        <!-- adult -->
        <template v-if="lodgerList.length">
          <div class="room-row" v-for="(people, mindex) in lodgerList" :key="mindex">
            <div class="row-content">
              <div class="elem center body full-w-select age-group">
                <a-select class="select-items" v-model="people.personType" @change="changePersonType()">
                  <a-select-option
                    v-for="(el, index) in setAllTypeData"
                    :value="el.value"
                    :key="`room-${index}`"
                  >
                    {{ el.value }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="elem center body member-type">
                <a-radio-group
                  v-model="people.type"
                  @change="changeInfo($event.target.value, people.index, 'type', people.personType)"
                  :disabled="disableVisitor"
                >
                <!-- PC -->
                <div class="flex md:hidden">
                  <a-radio value="member">会員</a-radio>
                  <a-radio value="visistor">ビジター</a-radio>
                </div>
                <!-- SP -->
                <div class="hidden md:block">
                  <a-radio value="member">会員</a-radio>
                  <a-radio value="visistor">ビジター</a-radio>
                </div>
                </a-radio-group>
              </div>
              <div class="elem center body sex-type">
                <a-radio-group
                  v-model="people.gender"
                  @change="changeInfo($event.target.value, people.index, 'gender', people.personType)"
                >
                  <!-- PC -->
                  <div class="flex md:hidden">
                    <a-radio value="male">男性</a-radio>
                    <a-radio value="female">女性</a-radio>
                  </div>
                  <!-- SP -->
                  <div class="hidden md:block">
                    <a-radio value="male">男性</a-radio>
                    <a-radio value="female">女性</a-radio>
                  </div>
                </a-radio-group>
              </div>
              <div class="elem center body main-accommodation">
                <a-checkbox
                  v-if="people.personType === allTypeLabel.adult.value"
                  :value="people.isDeputation"
                  :checked="people.isDeputation"
                  @change="changeDeputation(people.index)"
                />
              </div>
              <div class="elem center body delete-lodger">
                <a-button
                  @click="deleteLodger(people.index, people.personType, mindex, people.isDeputation)"
                  class="deleteLodger-btn"
                >
                  ×
                </a-button>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div>
        <a-button
          @click="addLodgerList()"
        >
          宿泊者を追加する
        </a-button>
      </div>
      <div v-if="deputationErrors.error_deputation" class="error-notification alert-message">
        {{ deputationErrors.error_deputation }}
      </div>
      <div v-if="Array.isArray(roomErrors) && roomErrors.length > 0">
        <p
          class="error-notification alert-message"
          v-for="(errorMsg, idx) in roomErrors"
          :key="`room-${idx}`"
        >
          {{ errorMsg }}
        </p>
      </div>
      
      <template>
        <div class="form-info">
          <div class="form-data mb-4">
            <div class="content">
              <p class="content__title">部屋代表者</p>
              <div class="items">
                <span class="label label--first">氏名（かな）<br />※全角かなで入力してください。</span>
                <div class="items-inner">
                  <div class="data">
                    <a-input
                      placeholder="べねふぃっと"
                      :maxLength="100"
                      class="mr-3"
                      v-model="representative.familyNameKana"
                      @change="onChangeFamilyNameKana"
                      wovn-ignore
                    />
                    <a-input
                      placeholder="はなこ"
                      :maxLength="100"
                      v-model="representative.firstNameKana"
                      @change="onChangeFirstNameKana"
                      wovn-ignore
                    />
                  </div>
                  <div class="error-notification alert-message">
                    {{ deputationErrors.error_name_kana }}
                  </div>
                </div>
              </div>
              <div class="items">
                <span class="label">氏名（ローマ字）<br />※半角ローマ字で入力してください。</span>
                <div class="items-inner">
                  <div class="data">
                    <a-input
                      @blur=""
                      :maxLength="100"
                      class="mr-3"
                      placeholder="Benefit"
                      v-model="representative.familyName"
                      @change="onChangeFamilyName"
                      wovn-ignore
                    />
                    <a-input
                      @blur=""
                      :maxLength="100"
                      placeholder="Hanako"
                      v-model="representative.firstName"
                      @change="onChangeFirstName"
                      wovn-ignore
                    />
                  </div>
                  <div class="error-notification alert-message">
                    {{ deputationErrors.error_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'

export default {
  mixins: [func_utils, plan_utils],
  props: {
    value: Object,
    numRoom: Number,
    vacancyCalendar: Array,
    roomErrors: {
      type: Array,
      default: () => []
    },
    deputationErrors: {
      type: Object,
      default: () => ({})
    },
    deputation: Array,
    savedAdultTypeData: Array,
    savedChildTypeData: Array,
    savedDeputyInfo: Array,
  },
  data() {
    return {
      warningMessage: {
        firstName: '名（ローマ字）を入力してください。',
        familyName: '姓（ローマ字）を入力してください。',
        gender: '性別を入力してください',
        age: '年齢を入力してください'
      },
      allTypeLabel: {
        adult: {value: '大人', childDiv: '0'},
        childrenType10: {value: '小学生高学年', childDiv: '10'},
        childrenType15: {value: '小学生低学年', childDiv: '15'},
        childrenType20: {value: '幼児食事・布団付', childDiv: '20'},
        childrenType30: {value: '幼児食事のみ', childDiv: '30'},
        childrenType40: {value: '幼児布団のみ', childDiv: '40'},
        childrenType50: {value: '幼児食事・布団不要', childDiv: '50'}
      },
      representative: {
        familyNameKana: '',
        familyName: '',
        firstNameKana: '',
        firstName: ''
      },
      adultTypeData: [],
      childTypeData: {
        childrenType10: [],
        childrenType15: [],
        childrenType20: [],
        childrenType30: [],
        childrenType40: [],
        childrenType50: []
      },
      lodgerList: [],
      dateFormat: 'YYYY/MM/DD',
      showPopoverMember: false,
      showPopoverVisitor: false,
      stayDayDetails: [],
      dataBinding: {
        roomPrice: null,
        stayDay: null,
        adultPrice: 0,
        member: {
          man: 0,
          woman: 0
        },
        visitors: {
          man: 0,
          woman: 0
        },
        chldaManHeadCnt: 0,
        chldaWomanHeadCnt: 0,
        memberChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        visitorChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        totalAmount: 0,
        roomAmount: 0,
        memberCount: 0,
        visitorCount: 0,
        childrenCount: 0
      },
      stayDay: null,
      stayNights: 0, // number of days
      price: {},
      maxStayCapacity: null,
      minStayCapacity: null,
      minRoomStock: null,
      roomCapacity: 0,
      limitRooms: 0,
      stateChildInfos: [],
      stateVacancyCalendars: [],
      baseDeputation: {
        gender: null,
        age: null,
        numRoom: null,
        isDeputation: false,
        index: null,
        personType: null,
        type: null,
        warningType: []
      },
    }
  },
  mounted() {
    if (this.value) {
      this.dataBinding = JSON.parse(JSON.stringify(this.value))
    }
    if (this.customerPlanState) {
      this.stayDay = this.customerPlanState.stayDay
      this.stayNights = this.customerPlanState.stayNights
      this.stayDayDetails = Array.isArray(this.customerPlanState.detailDays)
        ? this.customerPlanState.detailDays
        : []
      this.maxStayCapacity = this.customerPlanState.maxStayCapacity
      this.minStayCapacity = this.customerPlanState.minStayCapacity
    }
    this.minRoomStock = this.getMinRoomStock(this.stayDayDetails)
    if (this.isRakutenPLan) {
      this.setupAdultInfo();
      this.triggerChange();
      this.mountData();
    }
  },
  computed: {
    isRakutenPLan() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd') === 'RakutenT'
    },
    disableVisitor() {
      return this.getPlanInfo.planUsage?.usageDetailStay?.visitorAvailDiv === '0'
    },
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
    },
    selectedDayCalendar() {
      const vacancyCalendars = this.vacancyCalendar[this.numRoom]?.vacancyCalendars || []
      const stayDays = []
      for (let i = 0; i < this.stayNights; i++) {
        stayDays.push(moment(this.stayDay).add(i, 'days').format(this.dateFormat))
      }
      return vacancyCalendars.filter((v) =>
        stayDays.includes(moment(v.stayDay).format(this.dateFormat))
      )
    },
    countMemberChildren() {
      const memberChildren =
        this.dataBinding && this.dataBinding.memberChildren
          ? this.dataBinding.memberChildren
          : null
      return Object.keys(memberChildren)
        .map((key) => memberChildren[key])
        .reduce((a, b) => a + b, 0)
    },
    countVisitorChildren() {
      const visitorChildren =
        this.dataBinding && this.dataBinding.visitorChildren
          ? this.dataBinding.visitorChildren
          : null
      return Object.keys(visitorChildren)
        .map((key) => visitorChildren[key])
        .reduce((a, b) => a + b, 0)
    },
    roomAmount() {
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        const amount = this.stayDayDetails
          .map((e) => e.roomPrice)
          .reduce((pre, cur) => pre + cur, 0)
        return amount
      }
      const member =
        this.dataBinding && this.dataBinding.member ? this.dataBinding.member : null
      const visitor =
        this.dataBinding && this.dataBinding.visitors ? this.dataBinding.visitors : null
      const memberChildren =
        this.dataBinding && this.dataBinding.memberChildren
          ? this.dataBinding.memberChildren
          : null
      const visitorChildren =
        this.dataBinding && this.dataBinding.visitorChildren
          ? this.dataBinding.visitorChildren
          : null
      let amount = 0
      this.selectedDayCalendar.forEach((vacancy) => {
        // member adults
        amount += (member.man + member.woman) * vacancy.price
        // visitor adults
        amount += (visitor.man + visitor.woman) * vacancy.adultPrice
        // member childrens
        amount +=
          memberChildren.childrenType10 *
          this.getMemberChildPrice('childrenType10', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType15 *
          this.getMemberChildPrice('childrenType15', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType20 *
          this.getMemberChildPrice('childrenType20', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType30 *
          this.getMemberChildPrice('childrenType30', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType40 *
          this.getMemberChildPrice('childrenType40', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType50 *
          this.getMemberChildPrice('childrenType50', vacancy.childrenPriceTable)
        // visitor childrens
        amount +=
          visitorChildren.childrenType10 *
          this.getVisitorChildPrice('childrenType10', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType15 *
          this.getVisitorChildPrice('childrenType15', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType20 *
          this.getVisitorChildPrice('childrenType20', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType30 *
          this.getVisitorChildPrice('childrenType30', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType40 *
          this.getVisitorChildPrice('childrenType40', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType50 *
          this.getVisitorChildPrice('childrenType50', vacancy.childrenPriceTable)
      })
      return amount
    },
    totalChild() {
      return this.countMemberChildren + this.countVisitorChildren
    },
    totalPeopleCnt() {
      const adultMemberSlot = this.dataBinding.member.man + this.dataBinding.member.woman
      const adultVisitorSlot =
        this.dataBinding.visitors.man + this.dataBinding.visitors.woman
      return adultMemberSlot + adultVisitorSlot + this.totalChild
    },
    setAllTypeData() {
      let availableTypeList = {
        adult: {value: '大人', childDiv: '0'},
        childrenType10: {value: '小学生高学年', childDiv: '10'},
        childrenType15: {value: '小学生低学年', childDiv: '15'},
        childrenType20: {value: '幼児食事・布団付', childDiv: '20'},
        childrenType30: {value: '幼児食事のみ', childDiv: '30'},
        childrenType40: {value: '幼児布団のみ', childDiv: '40'},
        childrenType50: {value: '幼児食事・布団不要', childDiv: '50'}
      };
      let childInfos = this.vacancyCalendar[0]?.childPriceInfo?.childInfos;
      let peopleCount  = 0;
      
      // vacancy-calendarAPIでエラーが発生するとundefinedになるため、別のAPIデータを使用
      if(!childInfos){
        childInfos =  _.get(this.getPlanInfo, 'vacancyCalendar.childPriceInfo.childInfos')
      }
      for (const person in this.lodgerList) {
        if (this.lodgerList[person].personType === this.allTypeLabel.adult.value) {
          peopleCount++;
        } else {
          Object.keys(this.dataBinding.memberChildren).forEach((child) => {
            const childType  = this.allTypeLabel[child].value;
            const childDiv   = this.allTypeLabel[child].childDiv;
            if (this.lodgerList[person].personType === childType) {
              for (let index in childInfos) {
                if (childDiv === childInfos[index].childDiv) {
                  childInfos[index].calc === '1' ? peopleCount++ : null;
                }
              }
            }
          })
        }
      }

      for (let item in availableTypeList) {
        const childDiv = availableTypeList[item].childDiv;
        let judge = false;
        for (let index in childInfos) {
          const acceptance = childDiv === childInfos[index].childDiv;
          if (acceptance) {
            judge = true;
            break;
          }
        }
        // 大人を除いたプランで無効な子供区分削除(選択可能な区分を残す)
        if (!judge && childDiv !== '0') {
          delete availableTypeList[item];
        }
      }
      return availableTypeList;
    },
    profileMe() {
      // 1部屋目にのみユーザ情報反映
      if(this.numRoom === 0){
        return this.$store.getters['auth/get'].profileMe
      }
      else{
        return null
      }
    },
  },
  watch: {
    totalPeopleCnt() {
      this.dataBinding.roomAmount = this.roomAmount
      this.dataBinding.childrenCount = this.totalChild
      this.$emit('input', this.dataBinding)
      const adultMemberSlot = this.dataBinding.member.man + this.dataBinding.member.woman
      const adultVisitorSlot =
        this.dataBinding.visitors.man + this.dataBinding.visitors.woman
      this.$emit('changePeopleCnt', adultMemberSlot + adultVisitorSlot + this.totalChild)
      this.triggerChange()
    },
    roomAmount() {
      this.dataBinding.roomAmount = this.roomAmount
      this.dataBinding.childrenCount = this.totalChild
      this.$emit('input', this.dataBinding)
      this.triggerChange()
    },
    deputation(people) {
      if (!_.isEmpty(people) && people.numRoom !== this.numRoom) {
        this.removeDeputation()
      }
    },
    vacancyCalendar() {
      if(this.vacancyCalendar?.vacancyCalendars || this.vacancyCalendar?.childPriceInfo){
        this.stateVacancyCalendars = this.vacancyCalendar.vacancyCalendars || [];
        this.stateChildInfos = this.vacancyCalendar.childPriceInfo?.childInfos || [];
      }
    },
  },
  methods: {
    mountData() {
      this.$nextTick(() => {
        if(this.savedAdultTypeData != null){
          this.adultTypeData.forEach((people, index) => {
            if(this.savedAdultTypeData[index]){
              people.age = this.savedAdultTypeData[index].age
              people.gender = this.savedAdultTypeData[index].gender
              people.index = this.savedAdultTypeData[index].index
              people.isDeputation = this.savedAdultTypeData[index].isDeputation
              people.numRoom = this.savedAdultTypeData[index].numRoom
              people.personType = this.savedAdultTypeData[index].personType
              people.type = this.savedAdultTypeData[index].type
              people.warningType = this.savedAdultTypeData[index].warningType
            }
          })
          this.countNewAdultMember()
        }
        if(this.savedChildTypeData != null){
          Object.keys(this.dataBinding.memberChildren).forEach((childType) => {
            if(this.savedChildTypeData[childType].length > 0)
            this.childTypeData[childType].forEach((people, index) => {          
              people.age = this.savedChildTypeData[childType][index].age
              people.gender = this.savedChildTypeData[childType][index].gender
              people.index = this.savedChildTypeData[childType][index].index
              people.isDeputation = this.savedChildTypeData[childType][index].isDeputation
              people.numRoom = this.savedChildTypeData[childType][index].numRoom
              people.personType = this.savedChildTypeData[childType][index].personType
              people.type = this.savedChildTypeData[childType][index].type
              people.warningType = this.savedChildTypeData[childType][index].warningType
            })
          })
          this.countNewChildMember()
        }
      })
      if(this.savedDeputyInfo != null){
        this.representative.familyNameKana = this.savedDeputyInfo.familyNameKana
        this.representative.firstNameKana = this.savedDeputyInfo.firstNameKana
        this.representative.familyName = this.savedDeputyInfo.familyName
        this.representative.firstName = this.savedDeputyInfo.firstName
        this.changeRepresentative()
      }
      else if(this.profileMe !== null){
        const familyNameHira = this.onReplaceZenKataWithHira(this.profileMe.familyNameKana)
        this.representative.familyNameKana = this.onReplaceHira(familyNameHira)
        const firstNameHira = this.onReplaceZenKataWithHira(this.profileMe.firstNameKana)
        this.representative.firstNameKana = this.onReplaceHira(firstNameHira)
        this.representative.familyName = this.onReplaceRomaji(this.profileMe.familyNameRomanji)
        this.representative.firstName = this.onReplaceRomaji(this.profileMe.firstNameRomanji)
        this.changeRepresentative()
      }
    },
    setupAdultInfo() {
      this.$nextTick(() => {
        if (this.value.adultCount) {
          for (let i = 1; i <= this.value.adultCount; i++) {
            const adultObject = {
              index: i,
              type: 'member',
              gender: 'male',
              age: null,
              isDeputation: false,
              warningType: [],
              numRoom: this.numRoom,
              personType: '大人'
            };
            this.adultTypeData.push(adultObject);
            this.lodgerList.push(adultObject);
          }
          this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom)
        }
      })
      this.$nextTick(() => {
        if (this.dataBinding.childrenCount || true) {
          Object.keys(this.dataBinding.memberChildren).forEach((child) => {
            const count = this.dataBinding.memberChildren[child]
            if (count) {
              let i = 0;
              for (i = 1; i <= count; i++) {
                const childObject = {
                  index: i,
                  type: 'member',
                  gender: 'male',
                  age: null,
                  warningType: [],
                  personType: this.allTypeLabel[child].value
                };
                this.childTypeData[child].push(childObject);
                this.lodgerList.push(childObject);
              }
              this.dataBinding.chldaManHeadCnt += (i - 1);
              this.$emit('changeChildTypeData', this.childTypeData, this.numRoom)
            }
          })
        }
      })
    },
    removeDeputation() {
      this.adultTypeData.forEach((people) => {
        people.isDeputation = false
      })
    },
    changeDeputation(index) {
      this.adultTypeData.forEach((people) => {
        if (people.index == index) {
          people.isDeputation = true;
          this.$emit('changeDeputation', people, this.numRoom)
        } else {
          people.isDeputation = false;
        }
      })
      this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom);
      this.$forceUpdate();
    },
    changeRepresentative() {
      this.$emit('changeRepresentative', this.representative, this.numRoom)
    },
    onChangeFamilyNameKana(e) {
      const input = e.target.value
      this.representative.familyNameKana = this.onReplaceHira(input)
      this.changeRepresentative()
    },
    onChangeFirstNameKana(e) {
      const input = e.target.value
      this.representative.firstNameKana = this.onReplaceHira(input)
      this.changeRepresentative()
    },
    onChangeFamilyName(e) {
      const input = e.target.value
      this.representative.familyName = this.onReplaceRomaji(input)
      this.changeRepresentative()
    },
    onChangeFirstName(e) {
      const input = e.target.value
      this.representative.firstName = this.onReplaceRomaji(input)
      this.changeRepresentative()
    },
    countNewAdultMember() {
      let memberMan = 0
      let memberWoman = 0
      let visistorMan = 0
      let visistorWoman = 0
      this.adultTypeData.forEach((people) => {
        switch (people.type) {
          case 'member':
            if (people.gender === 'male') memberMan++
            else if (people.gender === 'female') memberWoman++
            break
          case 'visistor':
            if (people.gender === 'male') visistorMan++
            else if (people.gender === 'female') visistorWoman++
            break

          default:
            break
        }
      })
      this.dataBinding.member.man = memberMan
      this.dataBinding.member.woman = memberWoman
      this.dataBinding.visitors.man = visistorMan
      this.dataBinding.visitors.woman = visistorWoman
      this.dataBinding.adultCount = memberMan + memberWoman + visistorMan + visistorWoman
    },
    countNewChildMember() {
      let member = {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      }
      let visistor = {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      }
      let childMan = 0
      let childWoman = 0
      Object.keys(this.dataBinding.memberChildren).forEach((childType) => {
        this.childTypeData[childType].forEach((people) => {
          if (people.gender) {
            switch (people.type) {
              case 'member':
                member[childType]++
                break
              case 'visistor':
                visistor[childType]++
                break
              default:
                break
            }
            if (people.gender === 'male') {
              childMan++
            } else if (people.gender === 'female'){
              childWoman++
            }
          }
        })
      })
      this.dataBinding.memberChildren = member
      this.dataBinding.visitorChildren = visistor
      this.dataBinding.chldaManHeadCnt = childMan
      this.dataBinding.chldaWomanHeadCnt = childWoman
    },
    changeInfo(val, index, key, personType) {
      if(personType === this.allTypeLabel.adult.value) {
        this.changeAdultInfo(val, index, key);
      } else {
        Object.keys(this.dataBinding.memberChildren).forEach((child) => {
          const childType = this.allTypeLabel[child].value;
          if(personType === childType) {
            this.changeChildInfo(val, index, key, child);
          }
        })
      }
    },
    changeAdultInfo(val, index, key) {
      //validate romaji
      if (['firstName', 'familyName'].includes(key)) {
        const people = this.adultTypeData.find((people) => people.index == index)
        if (this.validateTextKanjiRomaji(val)) {
          people.warningType = people.warningType.filter((type) => type !== key)
          return
        } else {
          if (!people.warningType.some((type) => type === key)) {
            people.warningType.push(key)
            return
          }
        }
      }
      //check null gender, type
      const people = this.adultTypeData.find((people) => people.index == index);
      const listCheckNullKey = ['gender', 'type']
      if (key === 'gender') {
        people.gender = val;
      } else if (key === 'type') {
        people.type = val;
      }
      listCheckNullKey.forEach((nullKey) => {
        if (people[nullKey] === null || people[nullKey] === '') {
          if (!people.warningType.some((type) => type === nullKey)) {
            people.warningType.push(nullKey)
          }
        } else {
          people.warningType = people.warningType.filter((type) => type !== nullKey)
        }
      })
      if (people.isDeputation) {
        this.changeDeputation(people.index)
      }
      this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom, true)
      this.countNewAdultMember();
      this.triggerChange();
    },
    changeChildInfo(val, index, key, childType) {
      //validate romaji
      if (['firstName', 'familyName'].includes(key)) {
        const people = this.childTypeData[childType].find(
          (people) => people.index == index
        )
        if (this.validateTextKanjiRomaji(val)) {
          people.warningType = people.warningType.filter((type) => type !== key)
          return
        } else {
          if (!people.warningType.some((type) => type === key)) {
            people.warningType.push(key)
            return
          }
        }
      }
      //check null gender, type
      const people = this.childTypeData[childType].find((people) => people.index == index);
      const listCheckNullKey = ['gender', 'type']
      listCheckNullKey.forEach((nullKey) => {
        if (people[nullKey] === null || people[nullKey] === '') {
          if (!people.warningType.some((type) => type === nullKey)) {
            people.warningType.push(nullKey)
          }
        } else {
          people.warningType = people.warningType.filter((type) => type !== nullKey)
        }
      })
      this.$emit('changeChildTypeData', this.childTypeData, this.numRoom, true)
      this.countNewChildMember();
      this.triggerChange();
    },
    triggerChange() {
      this.$emit('change', this.dataBinding);
    },
    deleteLodger(index, personType, mindex, isDeputation) {
      if (personType === this.allTypeLabel.adult.value) {
        if (this.adultTypeData.length === 1 || this.lodgerList.length === 1) {
          return
        }
        this.adultTypeData.splice(index - 1, 1);
        for (let i = 1; i <= this.adultTypeData.length; i++) {
          this.adultTypeData[i - 1].index = i;
        }
        this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom);
        this.countNewAdultMember();
        if (isDeputation){
          this.baseDeputation.numRoom = this.numRoom
          this.$emit('changeDeputation', this.baseDeputation, this.numRoom);
        }
      } else {
        if (this.lodgerList.length === 1){
          return
        }
        Object.keys(this.dataBinding.memberChildren).forEach((child) => {
          const childType = this.allTypeLabel[child].value;
          if (personType === childType) {
            this.childTypeData[child].splice(index - 1, 1);
            if (this.childTypeData[child].length > 0) {
              for (let i = 1; i <= this.childTypeData[child].length; i++) {
                this.childTypeData[child][i - 1].index = i;
              }
            }
          }
          this.$emit('changeChildTypeData', this.childTypeData, this.numRoom);
          this.countNewChildMember();
          this.triggerChange();
        })
      }
      this.triggerChange();
      this.lodgerList.splice(mindex, 1);
      // this.$forceUpdate();
    },
    addLodgerList() {
      const count = this.adultTypeData.length + 1;
      const adultObject = {
        index: count,
        type: 'member',
        gender: 'male',
        age: null,
        isDeputation: false,
        warningType: [],
        numRoom: this.numRoom,
        personType: '大人'
      };
      let peopleCount = 0;
      for (const person in this.lodgerList) {
        if (this.lodgerList[person].personType === this.allTypeLabel.adult.value) {
          peopleCount++;
        } else {
          Object.keys(this.dataBinding.memberChildren).forEach((child) => {
            const childType  = this.allTypeLabel[child].value;
            const childDiv   = this.allTypeLabel[child].childDiv;
            const childInfos = this.vacancyCalendar[0]?.childPriceInfo?.childInfos;
            if (this.lodgerList[person].personType === childType) {
              for (let index in childInfos) {
                if (childDiv === childInfos[index].childDiv && !['30', '50'].includes(childInfos[index].childDiv)) {
                  peopleCount++;
                }
              }
            }
          })
        }
      }

      if (this.maxStayCapacity && peopleCount >= +this.maxStayCapacity) {
        this.$toasted.error('1部屋に宿泊可能な人数上限です。');
        return;
      }
      if (this.vacancyCalendar?.errorCode) {
        this.$toasted.error('システムエラーが発生しました。');
        return;
      }

      this.adultTypeData.push(adultObject);
      this.lodgerList.push(adultObject);
      this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom);
      this.countNewAdultMember();
      this.triggerChange();
    },
    changePersonType() {
      let adultData = [];
      let childData = {
        childrenType10: [],
        childrenType15: [],
        childrenType20: [],
        childrenType30: [],
        childrenType40: [],
        childrenType50: []
      };
      let adultCount = 1;
      let childCount = {
        childrenType10: 1,
        childrenType15: 1,
        childrenType20: 1,
        childrenType30: 1,
        childrenType40: 1,
        childrenType50: 1
      };
      let changeDeputationFlag = false
      for (let i = 0; i < this.lodgerList.length; i++) {
        if(this.lodgerList[i].personType === this.allTypeLabel.adult.value) {
          this.lodgerList[i].index = adultCount++;
          adultData.push(this.lodgerList[i]);
        } else {
          // 64187:代表者にチェックがついている状態から子供に変更された時のフラグ切り替え
          if (this.lodgerList[i].isDeputation === true){
            this.lodgerList[i].isDeputation = false
            changeDeputationFlag = true;
          }
          Object.keys(this.dataBinding.memberChildren).forEach((child) => {
            const childType = this.allTypeLabel[child].value;
            if(this.lodgerList[i].personType === childType) {
              this.lodgerList[i].index = childCount[child]++;
              childData[child].push(this.lodgerList[i]);
            }
          })
        }
      }
      this.adultTypeData = adultData;
      this.childTypeData = childData;
      if(changeDeputationFlag){
        this.baseDeputation.numRoom = this.numRoom
        this.$emit('changeDeputation', this.baseDeputation, this.numRoom);
      }
      this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom, true);
      this.$emit('changeChildTypeData', this.childTypeData, this.numRoom, true);
      this.countNewAdultMember();
      this.countNewChildMember();

      // 75972 ベネ楽プランで年齢区分変更時にvacancy-calender APIを実行するよう改修
      // vacancy-calender API実行に必要な値をemit
      this.dataBinding.roomAmount = this.roomAmount
      this.dataBinding.childrenCount = this.totalChild
      this.$emit('input', this.dataBinding)
      // vacancy-calender APIを実行
      this.$emit('changePersonType')
    }
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.items-inner {
  width: 80% !important;
}

.ant-radio-group {
  display: flex;
}

.bgGray {
  background-color: #F4F5F6 !important;
}

.label {
  position: relative;
  line-height: 1.4;
  &::after {
    content: "必須";
    position: absolute;
    top: 5%;
    right: 35%;
    padding: 0.25rem;
    --tw-text-opacity: 1;
    color: rgba(218, 41, 28, var(--tw-text-opacity));
    font-size: 10px;
    font-weight: normal;
    width: 30px;
    height: 25px;
    border: 1px solid #da291c;
    border-radius: 3px;
  }
  &.label--first::after {
    right: 45%;
  }
}

.content {
  &__item {
    span {
      padding: 0.25rem;
      --tw-text-opacity: 1;
      color: rgba(218, 41, 28, var(--tw-text-opacity));
      font-size: 10px;
      font-weight: normal;
      height: 25px;
      border: 1px solid #da291c;
      border-radius: 3px;
    }
  }

  &__title {
    margin-top: 20px;
    font-size: 18px;
    font-weight: bold;
  }
}

@media (max-width: 800px) {
  .deleteLodger-btn {
    padding: 0 5px;
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__item {
      flex-direction: column;
      span {
        display: block;
      }
    }

    &__title {
      font-size: 16px;
    }
  }

  .label {
    &::after {
    content: "必須";
    right: 45%;
  }
    &.label--first::after {
      right: 55%;
    }
  }

  .items-inner {
    width: 100% !important;
  }
}
</style>
